import { createListenerMiddleware } from "@reduxjs/toolkit";

import startPersistListener from "./persist";
import startSetDeviationListener from "./setDeviation";
import startSetRecipeModalListener from "./setRecipeModal";
import startToggleCartModalListener from "./toggleCart";
import startSetUpdateAddonToDeviationListener from "./updateAddonToDeviation";
import startSetSignupCouponListener from "./setSignupCoupon";
import startSubmitCouponListener from "./submitCoupon";
import startSubmitGiftcardListener from "./submitGiftcard";
import startRegistrationListener from "./registration";
import startSetAddonProductsListener from "./setAddonProducts";
import startSendTellAFriendSmsListener from "./sendRecruitmentSms";
import startSignupListener from "./signup";
import startUpdateBillingAgreementListener from "./updateBillingAgreement";
import startCreateOrUpdateMultipleSchedulersListener from "./createOrUpdateMultipleSchedulers";
import startCreateOrUpdateSchedulerListener from "./createOrUpdateScheduler";
import startUpdateAddressListener from "./updateAddress";
import startCreateAddressListener from "./createAddress";
import startUpdateContactPreferencesListener from "./updateContactPreferences";
import startUpdateUserInformationListener from "./updateUserInformation";
import startUpdatePasswordListener from "./updatePassword";
import startUpdateUserConsentListener from "./updateUserConsent";
import startSubmitRatingAndCommentRecipeListener from "./addOrUpdateRating";
import startValidateBasketMutationListener from "./validateBasketMutation";
import startCreateOrUpdateDeviationsByBasketIdsListener from "./createOrUpdateDeviationsByBasketIdsMutation";
import startUpdateBillingAgreementAddonsListener from "./updateBillingAgreementAddons";
import startDeliveryRatingListener from "./deliveryRating";
import startUpdateAgreementBasketProductsListener from "./updateAgreementBasketProducts";

export const listenerMiddleware = createListenerMiddleware();

startPersistListener(listenerMiddleware);
startSetDeviationListener(listenerMiddleware);
startSetRecipeModalListener(listenerMiddleware);
startToggleCartModalListener(listenerMiddleware);
startSetUpdateAddonToDeviationListener(listenerMiddleware);
startSetSignupCouponListener(listenerMiddleware);
startSubmitCouponListener(listenerMiddleware);
startSubmitGiftcardListener(listenerMiddleware);
startRegistrationListener(listenerMiddleware);
startSetAddonProductsListener(listenerMiddleware);
startSendTellAFriendSmsListener(listenerMiddleware);
startSignupListener(listenerMiddleware);
startUpdateBillingAgreementListener(listenerMiddleware);
startCreateOrUpdateMultipleSchedulersListener(listenerMiddleware);
startCreateOrUpdateSchedulerListener(listenerMiddleware);
startUpdateAddressListener(listenerMiddleware);
startCreateAddressListener(listenerMiddleware);
startUpdateContactPreferencesListener(listenerMiddleware);
startUpdateUserInformationListener(listenerMiddleware);
startUpdatePasswordListener(listenerMiddleware);
startUpdateUserConsentListener(listenerMiddleware);
startSubmitRatingAndCommentRecipeListener(listenerMiddleware);
startValidateBasketMutationListener(listenerMiddleware);
startCreateOrUpdateDeviationsByBasketIdsListener(listenerMiddleware);
startUpdateBillingAgreementAddonsListener(listenerMiddleware);
startDeliveryRatingListener(listenerMiddleware);
startUpdateAgreementBasketProductsListener(listenerMiddleware);

export * from "./util";
